import {SrcSet} from '@yandex-delivery/assets'
import type {Account} from './types'

const DEFAULT_AVATAR_ID = '0/0-0'

const avatarSrcSets = new SrcSet('islands-middle', 'islands-retina-middle', 'islands-retina-50')

export const getDefaultAndRestAccounts = (accounts: Account[], defaultUid?: string) => {
  const mayBeAccount = defaultUid && accounts.find(item => item.uid === defaultUid)
  const defaultAccount = mayBeAccount || accounts[0]

  if (defaultAccount) {
    const restAccounts = accounts.filter(user => user !== defaultAccount)

    return [defaultAccount, restAccounts] as const
  }

  throw new Error('passport user not found')
}

export const getAvatarSrcSet = (urlPrefix: string) => avatarSrcSets.map(x => `${urlPrefix}/${x}`)

export const toAvatarSources = (avatarUrl: string, avatarId: string = DEFAULT_AVATAR_ID) =>
  getAvatarSrcSet(`${avatarUrl}/${avatarId}`)

export const toPassportUrls = (passportHost: string, returnPath: string, yui: string, origin = 'dostavka') => {
  return {
    camera: `${passportHost}/profile/public?retpath=${returnPath}`,
    profile: `${passportHost}/profile`,
    signIn: `${passportHost}/auth?retpath=${returnPath}&mode=add-user&origin=${origin}`,
    signOut: `${passportHost}/passport?retpath=${returnPath}&mode=logout&yu=${yui}&origin=${origin}`,
  } as const
}

export const safeReturnPath = (path: string): string => {
  try {
    return decodeURIComponent(path)
  } catch (e) {
    return path
  }
}
